module.exports = __webpack_public_path__ + "static/media/platicasPrematiminiales.ddd629e4.jpg";